import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@cm/components/ui/button";
import { Home, ArrowLeft, Shield, Users } from "lucide-react";
import { motion } from "framer-motion";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const isAdmin = location.pathname.startsWith("/admin");
  const isMember = location.pathname.startsWith("/member");

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background to-muted">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md px-6 text-center"
      >
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="mb-2 text-8xl font-extrabold text-primary/20"
        >
          404
        </motion.div>
        <h1 className="mb-2 text-2xl font-bold text-foreground">
          Page Not Found
        </h1>
        <p className="mb-6 text-muted-foreground">
          The page{" "}
          <code className="rounded bg-muted px-2 py-0.5 text-sm">
            {location.pathname}
          </code>{" "}
          doesn't exist.
        </p>
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-1 h-4 w-4" />
            Go Back
          </Button>
          {isAdmin && (
            <Button onClick={() => navigate("/admin")}>
              <Shield className="mr-1 h-4 w-4" />
              Admin Dashboard
            </Button>
          )}
          {isMember && (
            <Button onClick={() => navigate("/member")}>
              <Users className="mr-1 h-4 w-4" />
              Member Portal
            </Button>
          )}
          <Button
            variant={isAdmin || isMember ? "outline" : "default"}
            onClick={() => navigate("/")}
          >
            <Home className="mr-1 h-4 w-4" />
            Home
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
